import { APP_ROUTES } from 'shared/constants/navigation';

function hasBusinessDetails(webstore) {
    const addresses = webstore?.Addresses;
    const hasAddressesArray = Array.isArray(addresses);
    const addressesLength = hasAddressesArray ? addresses.length : 0;

    console.log('[VendorConnectRedirect] business-details-check', {
        hasAddressesArray,
        addressesLength,
        addressesPreview: hasAddressesArray
            ? addresses.slice(0, 3).map((address, index) => ({
                  index,
                  addressType: address?.addressType || null,
                  hasAddress1: Boolean(`${address?.address1 || ''}`.trim()),
                  hasCity: Boolean(`${address?.city || ''}`.trim()),
                  hasState: Boolean(`${address?.state || ''}`.trim()),
                  hasZipCode: Boolean(`${address?.zipCode || ''}`.trim()),
              }))
            : [],
    });

    return hasAddressesArray && addressesLength > 0;
}

function setTokenCookie(name, value) {
    if (!value) {
        console.log('[VendorConnectRedirect] cookie-skip-no-value', { name });
        return;
    }
    const encodedValue = encodeURIComponent(value);
    const maxAgeSeconds = 60 * 60 * 24;
    document.cookie = `${name}=${encodedValue}; Max-Age=${maxAgeSeconds}; Path=/; Domain=.davidsbridal.com; Secure; SameSite=Lax`;
    console.log('[VendorConnectRedirect] cookie-set', {
        name,
        valueLength: String(value).length,
    });
}

function redirectToVendorConnectOrFallback(tokenService, navigate) {
    const baseUrl = process.env.REACT_APP_VENDORCONNECT_URL;
    const accessToken = tokenService?.getAccessToken?.();
    const refreshToken = tokenService?.getRefreshToken?.();
    const idToken = tokenService?.getIdToken?.();

    console.log('[VendorConnectRedirect] redirect-inputs', {
        baseUrl,
        hasBaseUrl: Boolean(baseUrl),
        hasAccessToken: Boolean(accessToken),
        accessTokenLength: accessToken ? accessToken.length : 0,
        hasRefreshToken: Boolean(refreshToken),
        refreshTokenLength: refreshToken ? refreshToken.length : 0,
        hasIdToken: Boolean(idToken),
        idTokenLength: idToken ? idToken.length : 0,
    });

    if (!baseUrl || !accessToken || !refreshToken || !idToken) {
        console.log('[VendorConnectRedirect] fallback-dashboard', {
            reason: 'missing-env-or-token',
            hasBaseUrl: Boolean(baseUrl),
            hasAccessToken: Boolean(accessToken),
            hasRefreshToken: Boolean(refreshToken),
            hasIdToken: Boolean(idToken),
            route: APP_ROUTES.vendor.dashboard,
        });
        navigate(APP_ROUTES.vendor.dashboard);
        return;
    }

    setTokenCookie('PEARL_VENDORCONNECT_ACCESS_TOKEN', accessToken);
    setTokenCookie('PEARL_VENDORCONNECT_REFRESH_TOKEN', refreshToken);
    setTokenCookie('PEARL_VENDORCONNECT_ID_TOKEN', idToken);
    console.log('[VendorConnectRedirect] redirecting', { target: baseUrl });
    window.location.assign(baseUrl);
}

export { hasBusinessDetails, redirectToVendorConnectOrFallback };
